import {
    ArchiveStatus,
} from 'app/enums/common.enums'
import useRequest, {
    RequestKeys,
    RequestFn,
    responseParser,
} from 'app/hooks/useRequest'

import requests from '../Contact.requests'

const useGetContactByIds = ({
    ids,
    archivedStatus = ArchiveStatus.ALL,
}: {
    ids: number[],
    archivedStatus?: ArchiveStatus,
}) => {
    return useRequest({
        key: RequestKeys.getContactByIds,
        params: {
            params: {
                data: {
                    includeFilters: {
                        id: ids,
                    },
                    archivedStatus,
                },
            },
        },
        requestFunc: RequestFn.getEntity(
            requests.filterRequest,
            responseParser.items,
        ),
        enabled: Boolean(ids.length),
        keepPreviousData: true,
    })
}

export default useGetContactByIds
